import { connect } from 'react-redux';
import React, { PropTypes } from 'react';
import { Form, Popup, Icon } from 'semantic-ui-react';
import { updateData } from '../actions/form';
import RadioOption from 'common/components/RadioOption';
import Products from './Products';

export class Recommendation extends React.Component {
  render() {
    return (
      <div>
        <Form.Field>
          <label>
            Type de protection
            <Popup
              trigger={
                <Icon name="question circle" style={{ marginLeft: '10px' }} />
              }
              basic
              flowing
            >
              Active: + 50 % du périmètre et/ou minimum 2 faces du bâti
              accessible pour station sol HD
              <br />
              Classique : - 50 % du périmètre et/ou moins de 2 faces du bâti
              accessible pour station sol HD
            </Popup>
          </label>
          <RadioOption
            name="protection"
            onChange={this.props.onActiveProtectionTypeChange}
            title=""
            value={this.props.activeProtectionType}
            customTrueLabel="Active"
            customFalseLabel="Classique"
            customNoneLabel="Je ne sais pas"
            readOnly={this.props.readOnly}
          />
        </Form.Field>
        <Products readOnly={this.props.readOnly} />
        <Form.TextArea
          label="Complément d'analyse de situation"
          value={this.props.diagnosticComment || ''}
          onChange={this.props.onDiagnosticCommentChange}
          readOnly={this.props.readOnly}
        />
        <Form.TextArea
          label="Commentaire interne"
          value={this.props.internalComment || ''}
          onChange={this.props.onInternalCommentChange}
          readOnly={this.props.readOnly}
        />
      </div>
    );
  }
}

Recommendation.propTypes = {
  activeProtectionType: PropTypes.bool,
  diagnosticComment: PropTypes.string,
  internalComment: PropTypes.string,

  onActiveProtectionTypeChange: PropTypes.func.isRequired,
  onDiagnosticCommentChange: PropTypes.func.isRequired,
  onInternalCommentChange: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  activeProtectionType: state.form.form.recommendation.activeProtectionType,
  diagnosticComment: state.form.form.recommendation.diagnosticComment,
  internalComment: state.form.form.recommendation.internalComment,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onActiveProtectionTypeChange: (_, value) =>
    dispatch(updateData('recommendation.activeProtectionType', value.value)),
  onDiagnosticCommentChange: (_, value) =>
    dispatch(updateData('recommendation.diagnosticComment', value.value)),
  onInternalCommentChange: (_, value) =>
    dispatch(updateData('recommendation.internalComment', value.value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Recommendation);



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-study/components/Recommendation.js